import { useQuery } from '@tanstack/react-query'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { DateRange, Device } from '../ContentRoi/types'

const handleFetch = async ({
  companyId,
  period,
  domainId,
  date,
  page,
  limit,
  device_category,
  queryType,
}: {
  companyId: string
  period: DateRange
  domainId?: string
  date: string
  page: number
  limit: number
  queryType?: 'non_branded'
  device_category?: Device
}) => {
  const url = new URL(
    `${SEO_SERVICE_BASE_URL}/companies/${companyId}/analytics-roi/top-organic-keywords/list`
  )
  url.searchParams.append('date', date)
  url.searchParams.append('interval', period)
  url.searchParams.append('page', page.toString())
  url.searchParams.append('limit', limit.toString())
  domainId && url.searchParams.append('domain_id', domainId)
  queryType && url.searchParams.append('query_type', queryType)
  device_category && url.searchParams.append('device_category', device_category)

  try {
    const response = await axios.get(url.toString())
    return response.data
  } catch (error) {
    return extract.error(error)
  }
}

export const useGetTopOrganicKeywordsList = ({
  companyId,
  isEnabled,
  period,
  domainId,
  date,
  page,
  limit,
  device_category,
  queryType,
}: {
  companyId: string
  isEnabled: boolean
  period: DateRange
  domainId?: string
  date: string
  page: number
  limit: number
  device_category?: Device
  queryType?: 'non_branded'
}) => {
  const {
    data: response,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: [
      'top-organic-keywords-list',
      companyId,
      period,
      domainId,
      date,
      page,
      limit,
      device_category,
      queryType,
    ],
    queryFn: () =>
      handleFetch({
        companyId,
        period,
        domainId,
        date,
        page,
        limit,
        device_category,
        queryType,
      }),
    enabled: isEnabled,
    refetchOnWindowFocus: false,
  })

  return {
    organicKeywordsList: response?.data,
    isLoading,
    isFetching,
    error,
    refetch,
  }
}
